import { GenericFormField, GenericFormSection } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";

function useFocusField<T extends Record<string, any>>(focusField?: string) {
  const hasFocusField = (field: GenericFormField<T> | GenericFormSection<T>, name?: string): boolean => {
    if (focusField === undefined) return false;

    if (field.type !== FormEnums.FormFieldType.EDITABLETABLE && field.innerFields !== undefined) {
      const innerObj = Array.isArray(field.innerFields)
        ? (field.innerFields as any).map((innerField: GenericFormSection<T>) => hasFocusField(innerField))
        : Object.entries(field.innerFields).map(([key, innerField]) => innerField && hasFocusField(innerField, key));

      return innerObj.some((val: boolean) => val);
    } else {
      return name === focusField;
    }
  };

  return { hasFocusField };
}

export default useFocusField;
